export default __webpack_public_path__ + "static/media/About-Tower-viajes-2@2x.212016a0.jpg";